var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components/native';
import theme from '../theme';
const ValidationIcon = styled((_a) => {
    var { customStyle, theme, component } = _a, rest = __rest(_a, ["customStyle", "theme", "component"]);
    return React.cloneElement(component, rest);
}) `
  ${({ customStyle }) => customStyle};
`;
ValidationIcon.defaultProps = {
    theme: {
        fifteenPT: theme.fifteenPT,
        thirtyPT: theme.thirtyPT,
    },
};
export default ValidationIcon;
